<div class="aj-loader-grid">
  {#each Array(9).fill(undefined) as i}
    <div></div>
  {/each}
</div>

<style lang="scss">
  $gap: 8;
  $size: 16;
  $delay: -0.4;

.aj-loader-grid {
  display: inline-block;
  position: relative;
  width: #{3 * ($gap + $size) + $gap}px;
  height: #{3 * ($gap + $size) + $gap}px;
}

.aj-loader-grid div {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #333;
  animation: aj-loader-grid 1.2s linear infinite;
}

@for $i from 1 through 9 {
  $lineNumber: 0;
  @if $i > 6 {
    $lineNumber: 2
  }
  @else if $i > 3 {
    $lineNumber: 1;
  }
  .aj-loader-grid div:nth-child(#{$i}) {
    top: calc(#{$gap}px + #{$lineNumber * ($gap + $size)}px);
    left: calc(#{$gap}px + #{(($i - 1) % 3) * ($gap + $size)}px);
    animation-delay: #{($lineNumber + (($i - 1) % 3)) * $delay}s;
  }
}
@keyframes aj-loader-grid {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

</style>